export default __webpack_public_path__ + "static/media/welcome_bg.468d35bd.png";